import React from "react";
import { CheckCircle2, PlayCircle, PauseCircle, Clock, XCircle, AlertTriangle } from "lucide-react";
import { cn } from "@/lib/utils";

export interface ProcessStatusBadgeProps {
  status?: string | null;
  className?: string;
  showIcon?: boolean;
}

export function ProcessStatusBadge({ status, className, showIcon = true }: ProcessStatusBadgeProps) {
  const norm = (status || "").toUpperCase();

  switch (norm) {
    case "COMPLETED":
      return (
        <span
          className={cn(
            "inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-bold bg-emerald-100 text-emerald-800 whitespace-nowrap",
            className
          )}
        >
          {showIcon && <CheckCircle2 className="w-3 h-3 text-emerald-700" />}
          <span>Đã xong</span>
        </span>
      );

    case "RUNNING":
    case "IN_PROGRESS":
      return (
        <span
          className={cn(
            "inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-bold bg-blue-100 text-blue-800 animate-pulse whitespace-nowrap",
            className
          )}
        >
          {showIcon && <PlayCircle className="w-3 h-3 text-blue-700" />}
          <span>Đang chạy</span>
        </span>
      );

    case "PAUSED":
      return (
        <span
          className={cn(
            "inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-bold bg-amber-100 text-amber-800 whitespace-nowrap",
            className
          )}
        >
          {showIcon && <PauseCircle className="w-3 h-3 text-amber-700" />}
          <span>Tạm dừng</span>
        </span>
      );

    case "ERROR":
      return (
        <span
          className={cn(
            "inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-bold bg-rose-100 text-rose-800 whitespace-nowrap",
            className
          )}
        >
          {showIcon && <XCircle className="w-3 h-3 text-rose-700" />}
          <span>Sự cố</span>
        </span>
      );

    case "READY":
      return (
        <span
          className={cn(
            "inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-bold bg-teal-100 text-teal-800 whitespace-nowrap",
            className
          )}
        >
          {showIcon && <Clock className="w-3 h-3 text-teal-700" />}
          <span>Sẵn sàng</span>
        </span>
      );

    case "PLANNED":
    default:
      return (
        <span
          className={cn(
            "inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-bold bg-slate-100 text-slate-700 whitespace-nowrap",
            className
          )}
        >
          {showIcon && <Clock className="w-3 h-3 text-slate-500" />}
          <span>Kế hoạch</span>
        </span>
      );
  }
}
